<svg
  [attr.width]="staticList.width"
  [attr.height]="staticList.height"
  [class]="staticList.iconClass"
  (click)="staticIconClick(staticList)"
  (keydown)="$event.stopPropagation()"
>
  <path
    *ngFor="let data of staticList.path; let i = index"
    [attr.d]="data"
    [class]="staticList.pathClass + (i + 1)"
    [attr.opacity]="
      staticList.name === 'sort'
        ? i === 0
          ? condition === 'asc'
            ? '1'
            : '0.2'
          : condition === 'desc'
            ? '1'
            : '0.2'
        : 1
    "
  />
  <rect
    *ngIf="staticList.rect"
    [attr.x]="staticList.rect.x"
    [attr.y]="staticList.rect.y"
    [attr.width]="staticList.rect.width"
    [attr.height]="staticList.rect.height"
    [attr.rx]="staticList.rect.rx"
    [attr.fill]="staticList.rect.fill"
  />
</svg>
